import React, { useState, useEffect } from "react";
import { NavLink} from "react-router-dom";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./About.css";

const members = [
  {
    name: "Walter Dzvairo",
    role: "Founder",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/walter-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "Gurvinder Singh",
    role: "Business Partner",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/gurvinder-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "Simon Kett",
    role: "Business Development ",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/simon-standard.png?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "David Hutchison",
    role: "Business Development ",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/david-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "Kieran Bloom",
    role: "Capital Allowances",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/kieran-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "Ebony Fletcher",
    role: "Recruitment",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/ebony-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
];
const testimonials = [
  {
    text: `"Total Care Advisory's guidance was invaluable. Their practical experiences truly made a difference in navigating CQC regulations and optimising our service."`,
    author: "Stephen R, Home Care Director, Bristol.",
  },
  {
    text: `"The team provided outstanding support throughout our registration process. Their expertise helped us achieve compliance quickly and confidently."`,
    author: "Sarah M, Care Home Manager, London.",
  },
  {
    text: `"Professional, knowledgeable, and responsive. We would highly recommend their consultancy services to any care provider."`,
    author: "James T, Registered Manager, Manchester.",
  },
];

const About = () => {

  const [active, setActive] = useState(0);
  const nextSlide = () => {
    setActive((prev) => (prev + 1) % members.length);
  };
  const prevSlide = () => {
    setActive((prev) => (prev - 1 + members.length) % members.length);
  };

    const [current, setCurrent] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
  
    useEffect(() => {
      if (isHovered) return;
  
      const interval = setInterval(() => {
        setCurrent((prev) => (prev + 1) % testimonials.length);
      }, 4000);
  
      return () => clearInterval(interval);
    }, [isHovered]);

    // open page on top //
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    // open page on top // 
    const navigate = useNavigate();


     const handleSeeMore = () => {
    navigate("/Services", {
      state: { scrollToContact: true },
    });
  };
    const handleSeeMore2 = () => {
    navigate("/", {
      state: { scrollToContact: true },
    });
  };
  const handleSeeMore3 = () => {
    navigate("/Insights", {
      state: { scrollToContact: true },
    });
  };
 


  return (
   <>
    <div className="home-page">
                <div className="featured-card">
                    <h1 className="About-title">About Total Care Advisory</h1>
                    <p className="About-pera">Discover our commitment to transforming the care sector. We support care homes, nursing homes, and domiciliary services across the UK, ensuring compliance, operational excellence, and sustainable growth.</p>
                    <div className="journey-container">
                        <section className="journey-section">
                            <div className="image-box">
                                <img src="https://images.unsplash.com/photo-1552664730-d307ca884978" alt="" />
                            </div>
                            <div className="content-box">
                                <h2>Our journey began with a <br /> clear purpose </h2>
                                <p> We started Total Care Advisory because we witnessed the stress and confusion many care providers faced with CQC registration and ongoing compliance. Passionate individuals with valuable experience often felt overwhelmed
                                    by complex regulations and administrative burdens. Our goal was to simplify this journey, offering practical and honest guidance to help build strong, compliant services that truly make a difference. </p>
                                <button className="About-btn" onClick={handleSeeMore}>Explore Services</button>
                            </div>
                        </section>
                        <section className="journey-section reverse">
                            <div className="image-box">
                                <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f" alt="" />
                            </div>
                            <div className="content-box">
                                <h2>Experience-driven consulting, <br /> not just theory </h2>
                                <p> What truly sets Total Care Advisory apart is our hands-on experience. We don’t just consult; we own and manage our own care homes. This means our advice on CQC compliance, inspections, and daily operations comes from real-world
                                    understanding, not just theoretical knowledge. We understand the challenges of staffing, regulatory pressures, and maintaining high standards of care. Our approach is practical, honest, and tailored to the unique realities
                                    of your care business. </p>
                                <button className="About-btn" onClick={handleSeeMore2}>Get In Touch</button>
                            </div>
                        </section>
                        <section className="journey-section">
                            <div className="image-box">
                                <img src="https://images.unsplash.com/photo-1517048676732-d65bc937f952" alt="" />
                            </div>
                            <div className="content-box">
                                <h2>Supporting your ambition <br />for excellence </h2>
                                <p> We partner with a wide range of care organisations, from new providers navigating CQC registration to established homes seeking to enhance compliance, improve inspection ratings, or streamline operations. Our clients share
                                    a common goal: to run high-quality, well-led, and financially sustainable services. We understand that excellent care and business success go hand in hand. Whether you're struggling with CQC expectations, inconsistent
                                    processes, or seeking to improve profitability without compromising care, we provide the practical support you need. </p>
                                <button className="About-btn" onClick={handleSeeMore3}>Read Our Insights</button>
                            </div>
                        </section>
                    </div>
                </div>
     </div>
     <section className="team-section">
      <h1 className="about-title">MEET OUR TEAM</h1>
      <p className="About-pera">Behind every service we provide is a dedicated team of professionals,each bringing their unique expertise <br/>  and enthusiasm to our business.</p>
      <div className="carousel-container">
        <button className="nav-arrow left" onClick={prevSlide}>
          ‹
        </button>
        <div className="carousel-track">
          {members.map((member, index) => {
            let position = index - active;
            if (position < -2) position += members.length;
            if (position > 2) position -= members.length;
            return (
              <div
                key={index}
                className={`Our_card ${index === active ? "active" : ""}`}
                style={{
                  transform: `translateX(${position * 220}px)
                              scale(${index === active ? 1 : 0.8})
                              rotateY(${position * -25}deg)`,
                  opacity: Math.abs(position) > 2 ? 0 : 1,
                  zIndex: 10 - Math.abs(position),
                }}>
                <img src={member.image} alt={member.name} draggable="false" />
              </div>
            );
          })}
        </div>

        <button className="nav-arrow right" onClick={nextSlide}>
          ›
        </button>
      </div>
      <div className="member-info">
        <h2 className="member-name">{members[active].name}</h2>
        <p className="member-role">{members[active].role}</p>
      </div>
    </section> 
     
     <section className="about-testimonial-slider"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="about-testimonial-content">
            <h2>{testimonials[current].text}</h2>
    
            <p>{testimonials[current].author}</p>
             <button className="OurServices-btn">
              <NavLink to="/insights">
             Let's get started
            </NavLink>
          </button>
          </div>
     </section>   
   </> 
  );
};

export default About;